module.exports = window["ReactLeaflet"];